import {Spin} from 'antd'
import _ from 'lodash'
import debounce from 'lodash/debounce'
import React, {useEffect} from 'react'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {NullAsDefault} from 'views/Shared'
import {API_ROOT_URL} from '../../envs/_current/config'
import {renderSelf} from "../../views/Shared";
import useTranslate from "../../modules/local/useTranslate";

function DebounceSelect({
                            name,
                            type,
                            fetchOptions,
                            renderOption = renderSelf,
                            onChange = NullAsDefault,
                            defaultOptions = [],
                            excludedOptions = [],
                            debounceTimeout = 300,
                            ...props
                        }) {
    const t = useTranslate()
    const [fetching, setFetching] = React.useState(false)
    const [options, setOptions] = React.useState(defaultOptions)
    const fetchRef = React.useRef(0)

    const debounceFetcher = React.useMemo(() => {
        const loadOptions = (value = '') => {
            fetchRef.current += 1
            const fetchId = fetchRef.current
            setFetching(true)
            fetchOptions(type, value, renderOption).then((newOptions) => {
                if (fetchId !== fetchRef.current) return
                setOptions(newOptions)
                setFetching(false)
            })
        }
        return debounce(loadOptions, debounceTimeout)
    }, [fetchOptions, debounceTimeout])

    useEffect(() => {
        const timeout = setTimeout(() => {
            debounceFetcher()  // setFetching(true) đã nằm trong loadOptions rồi
        }, 0)
        return () => clearTimeout(timeout)
    }, [])

    const getOptions = (options) => {
        let result = options ? Array.from(options ?? []) : undefined
        const array = Array.from(props.value ?? [])
        const matched = _.filter(excludedOptions, ({value}) => array.includes(value))
        if (!_.isEmpty(matched)) {
            result = [
                ...matched,
                ...result.filter(({value}) => !_.find(matched, {value})),
            ]
        }
        return result
    }

    const _options = getOptions(options)

    return (
        <SelectWidget
            showSearch
            allowClear={true}
            filterOption={false}
            onSearch={debounceFetcher}
            // Fix 1: suffixIcon thay vì notFoundContent
            // notFoundContent chỉ render khi list rỗng → spin bị ẩn khi đang refetch
            suffixIcon={fetching ? <Spin size="small"/> : undefined}
            placeholder={t('click to select')}
            onFocus={() => {
                debounceFetcher()
            }}
            onChange={(value, option) => {
                onChange(value, option)
                if (_.isEmpty(value)) {
                    debounceFetcher()
                }
            }}
            options={_options}
            loading={fetching}
            {...props}
            value={parseInt(_options?.length) === 0 ? undefined : props.value}
        />
    )
}

export async function fetchLookupList(type, keyword, renderOption = renderSelf) {
    return fetch(API_ROOT_URL + `/lookup/${type}/gets?keyword=${keyword}`)
        .then((response) => response.json())
        .then((body) => {
            let options = _.get(body, 'data', []).map((e) => ({
                label: renderOption(e.name),
                // Fix 2: dùng e.id làm value thay vì e.name
                // Nếu form lưu id (thường là UUID), phải nhất quán ở đây
                value: e.id,
                id: e.id,
            }))

            // Chỉ push keyword-as-option nếu keyword có giá trị
            // và không match bất kỳ id nào (logic cũ so sánh với e.name → luôn not found)
            const found = options.some((el) => el.label === keyword)
            if (keyword && !found) {
                options.push({
                    label: renderOption(keyword),
                    value: keyword,  // free-text, không có id
                    id: null,
                })
            }

            return [...options]
        })
}

export async function fetchLookupByTypeList(type, keyword, renderOption = renderSelf) {
    return fetch(API_ROOT_URL + `/lookup/${type}/get-by-types?keyword=${keyword}`)
        .then((response) => response.json())
        .then((body) => {
            let options = _.get(body, 'data', []).map((e) => ({
                label: renderOption(e.name),
                value: e.id,  // Fix 2 tương tự
                id: e.id,
            }))

            const found = options.some((el) => el.label === keyword)
            if (keyword && !found) {
                options.push({
                    label: renderOption(keyword),
                    value: keyword,
                    id: null,
                })
            }

            return [...options]
        })
}

export default DebounceSelect